module.exports = __webpack_public_path__ + "static/media/profile-6.a7053b73.png";